<ion-header>
  <ion-toolbar>
    <ion-title>Edit Image</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="croppieImage && originalBlob" class="image-uploader-base-wrapper">
    <curbnturf-image-uploader-base
      [options]="options"
      [croppieImage]="croppieImage"
      [originalBlob]="originalBlob"
      [maxDimensions]="maxDimensions"
      submitButtonText="Crop"
      (save)="saveFunction($event)"
      (close)="close()"
    >
    </curbnturf-image-uploader-base>
  </div>
</ion-content>
